<script lang="ts" setup>
import {useModalsStore} from "@/stores/modals";

import {Dialog} from "primevue";
import {ref, watch} from "vue";
import ky from "ky";
import type {TRequisite} from "@/components/profile/RequisiteItem.vue";

const form = ref<HTMLDivElement | null>(null)

const modalStore = useModalsStore()

watch(() => modalStore.isRequisitesShown, (val) => {
  if (!val) {
    return
  }

  setTimeout(() => {
    const formElement = form.value?.querySelector('form')

    // @ts-ignore
    window.Formie.initForm(formElement)

    const _form = form.value?.querySelector('form')

    if (!_form) {
      return
    }

    if (modalStore.activeRequisite) {
      form.value?.querySelectorAll('input').forEach((inputElement: HTMLInputElement) => {
        if (!inputElement.getAttribute('name')) {
          return
        }

        let name: keyof TRequisite | null = inputElement.getAttribute('name') as keyof TRequisite | null

        if (!name) {
          return;
        }

        if (name === 'entryTitle') {
          name = 'title'
        }

        if (name === 'phone[number]') {
          name = 'phone'
        }

        if (!modalStore.activeRequisite) {
          return;
        }

        // @ts-ignore
        inputElement.value = (modalStore.activeRequisite[name] && modalStore.activeRequisite[name].toString()) ?? null
      })
    }

    form.value?.querySelector('form')?.addEventListener('onAfterFormieValidate', async (e) => {
      e.preventDefault()

      const body = new FormData(_form)

      try {
        const response = await ky(`/requisites${modalStore.activeRequisite?.id ? '/' + modalStore.activeRequisite?.id : ''}`, {
          method: 'post',
          body
        })

        const detail = await response.json()

        window.dispatchEvent(new CustomEvent('requisitesUpdate', {
          detail
        }))

        setTimeout(() => {
          modalStore.hideRequisitesModal()
        }, 0)
      } catch (_) {
        // empty
      }
    })
  }, 0)
})
</script>

<template>
  <Dialog v-model:visible="modalStore.isRequisitesShown" :dismissable-mask="true" :show-header="false" append-to="self" modal pt:content:class="max-desktop:h-full" pt:mask:class="bg-black/30 transition-opacity cursor-pointer" pt:root:class="max-desktop:h-full max-desktop:w-full" pt:transition:name="fade-dialog">
    <div ref="form" class="bg-white w-full desktop:w-[1050px] p-[60px] relative max-desktop:h-full max-desktop:overflow-y-scroll">
      <slot/>
      <button class="absolute right-[30px] top-[30px] rounded-sm hover:text-[hsl(var(--roke-text-blue))] outline-none disabled:pointer-events-none transition-colors" tabindex="-1" type="button" @click="modalStore.hideRequisitesModal">
        <svg fill="none" height="25" viewBox="0 0 25 25" width="25" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.237178 0.489985L0.354307 0.354307C0.783775 -0.075161 1.45581 -0.114193 1.92937 0.237178L2.06505 0.354307L12.5 10.7887L22.935 0.354307C23.4074 -0.118096 24.1732 -0.118096 24.6457 0.354307C25.1181 0.826711 25.1181 1.59265 24.6457 2.06505L14.2113 12.5L24.6457 22.935C25.0752 23.3644 25.1142 24.0365 24.7628 24.51L24.6457 24.6457C24.2163 25.0752 23.5442 25.1142 23.0707 24.7628L22.935 24.6457L12.5 14.2113L2.06505 24.6457C1.59265 25.1181 0.826711 25.1181 0.354307 24.6457C-0.118096 24.1732 -0.118096 23.4074 0.354307 22.935L10.7887 12.5L0.354307 2.06505C-0.075161 1.63558 -0.114193 0.96355 0.237178 0.489985Z" fill="currentColor"/>
        </svg>
      </button>
    </div>
  </Dialog>
</template>